module.exports = __webpack_public_path__ + "static/media/pile-of-coin.b0a69f63.png";